import { useEffect, RefObject } from 'react';

interface UseOutsideClickProps {
  modalRef: RefObject<HTMLElement | null>;
  closeAction: () => void;
}

const useOutsideClick = ({ modalRef, closeAction }: UseOutsideClickProps) => {
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        closeAction(); // Trigger close action if clicked outside
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [modalRef, closeAction]);
};


export default useOutsideClick;
